import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Globe as GlobeIcon, Users, MapPin } from 'lucide-react';

const Globe: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="p-2 bg-teal-100 dark:bg-teal-900 rounded-lg">
          <GlobeIcon className="h-6 w-6 text-teal-600 dark:text-teal-400" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Global Employee Distribution
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Interactive 3D visualization of employee locations worldwide
          </p>
        </div>
      </div>

      {/* Globe Visualization */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MapPin className="h-5 w-5" />
            Interactive Globe
          </CardTitle>
          <CardDescription>
            Click on any point to focus on that location. Hover over points to see employee counts.
          </CardDescription>
        </CardHeader>
        <CardContent className="p-6">
          <div className="text-center py-12">
            <div className="text-lg font-semibold mb-2">Interactive Globe Available</div>
            <p className="text-muted-foreground mb-4">
              The interactive 3D globe is now available through the Dashboard.
            </p>
            <p className="text-sm text-muted-foreground">
              Click on the "Total Countries" widget in the Dashboard to open the fullscreen interactive globe experience.
            </p>
          </div>
        </CardContent>
      </Card>

      {/* Instructions */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            How to Use
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="font-semibold mb-2">Navigation Controls</h3>
              <ul className="space-y-1 text-sm text-gray-600 dark:text-gray-400">
                <li>• <strong>Mouse Drag:</strong> Rotate the globe</li>
                <li>• <strong>Mouse Wheel:</strong> Zoom in/out</li>
                <li>• <strong>Click Points:</strong> Focus on location</li>
                <li>• <strong>Hover Points:</strong> View employee count</li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-2">Color Legend</h3>
              <ul className="space-y-1 text-sm text-gray-600 dark:text-gray-400">
                <li>• <span className="inline-block w-3 h-3 bg-red-500 rounded-full mr-2"></span><strong>Red:</strong> 20+ employees</li>
                <li>• <span className="inline-block w-3 h-3 bg-orange-500 rounded-full mr-2"></span><strong>Orange:</strong> 10-19 employees</li>
                <li>• <span className="inline-block w-3 h-3 bg-yellow-500 rounded-full mr-2"></span><strong>Yellow:</strong> 5-9 employees</li>
                <li>• <span className="inline-block w-3 h-3 bg-green-500 rounded-full mr-2"></span><strong>Green:</strong> 2-4 employees</li>
                <li>• <span className="inline-block w-3 h-3 bg-blue-500 rounded-full mr-2"></span><strong>Blue:</strong> 1 employee</li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Globe;